export default "__VITE_ASSET__Dfq2XqyU__"